import React, { useState,useEffect  } from 'react';
import Sidebar from '../modules/main/Sidebar';
import Header from '../modules/main/Header';
import Footer from '../modules/main/Footer';
import { Card, Col, Row, Tabs, Tab, Tooltip as TooltipReact } from 'react-bootstrap';
import "react-dates/initialize";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import moment from 'moment';
import StaticDataTable from "../modules/custom/DataTable/StaticDataTable";
import APIService from "../api/APIService";

function HolidayCalendar({ name }) {

  const [activeTab, SetActiveTab] = useState("holiday_calendar");
  const [holidayList, setHolidayList] = useState([]);

   useEffect(() => {
    APIService.getHolidayList()
      .then((response) => {
        if (response && response.data && response.data.data) {
          setHolidayList(response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching holiday list:", error);
      });
  }, []);


  let holidayColumns = [
    {
      name: '#',
      id: 'srno',
      sortable: true,
      filterable: true,
      selector: (row, index) => index + 1,
    },
    {
      name: 'Festival',
      id: 'festival',
      sortable: true,
      filterable: true,
      selector: (row) => row?.holiday_name,
    },
    {
      name: 'Date',
      id: 'date',
      sortable: true,
      filterable: true,
      selector: (row) => moment(row?.holiday_date, 'YYYY-MM-DD').format('MMMM D, YYYY'),
    },
  ];


  

  return (
    <>
      <div>
        <Sidebar />
        <div className="main-content">
          <Header pagename={name ? name : ''} />
          <div className="inner-content">
              <Row className="mt-6">
                <Col xs={12}>
                  <Card className="rounded-10 border border-gray-100 mb-4">
                    <Card.Body className="p-0">
                      <div className="d-flex align-items-center px-3 px-md-4 py-3 border-bottom border-gray-100">
                        <h3 className="card-header-title mb-0 my-md-2 ps-md-3">Holiday Calendar List</h3>
                        <div className="ms-auto">
                          <Link to='/' className='btn btn-primary btn-sm'>Go to Dashboard</Link>
                        </div>
                      </div>
                    </Card.Body>
                    <Card.Body className="px-md-4 py-4">
                      <div className="px-md-3 py-md-3">
                          {holidayList && holidayList.length > 0 && (
                            <StaticDataTable 
                                columns={holidayColumns} 
                                data={holidayList} 
                                isExport={false} 
                                paginationPerPageCustom={20}
                            />
                            )}
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
}

export default HolidayCalendar;